module.exports = __webpack_public_path__ + "static/total-invested-assets-graph.8ce596a3.webp";